export function mapNewDate(date: Date): Date {
	if (!date) return new Date();

	return new Date(date);
}
